import { render, staticRenderFns } from "./pageFooter.vue?vue&type=template&id=5d1464db&scoped=true"
import script from "./pageFooter.vue?vue&type=script&lang=js"
export * from "./pageFooter.vue?vue&type=script&lang=js"
import style0 from "./pageFooter.vue?vue&type=style&index=0&id=5d1464db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../Retirement Planner.Admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1464db",
  null
  
)

export default component.exports